'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.getProductItemPriceInfo = exports.getShipmentDelayStatusLabel = exports.calculateAmountInfoByItemList = void 0;
function calculateAmountInfoByItemList(item_list, shipping_info, extra_shipping_fee) {
  const { has_free_shipping_item, total_item_amount } = item_list.reduce(
    (result, item) => {
      if (item.free_shipping) {
        result.has_free_shipping_item = true;
      }
      result.total_item_amount += item.total_amount;
      return result;
    },
    { has_free_shipping_item: false, total_item_amount: 0 },
  );
  const free_shipping =
    has_free_shipping_item ||
    (shipping_info.free_shipping_amount && shipping_info.free_shipping_amount <= total_item_amount);
  const total_shipping_fee = free_shipping ? extra_shipping_fee : shipping_info.shipping_fee + extra_shipping_fee;
  return {
    total_item_amount,
    total_shipping_fee: total_item_amount === 0 ? 0 : total_shipping_fee,
  };
}
exports.calculateAmountInfoByItemList = calculateAmountInfoByItemList;
function getShipmentDelayStatusLabel(due_date_in_transit, shipping_schedule_delay_info) {
  if (!due_date_in_transit) {
    return '-';
  }
  const delay_count = shipping_schedule_delay_info.count;
  const now = new Date();
  if (delay_count === 0) {
    return due_date_in_transit > now.getTime() ? '-' : '배송지연';
  }
  return due_date_in_transit > now.getTime()
    ? `연기 안내 완료(${delay_count}회)`
    : `배송지연/연기안내 (${delay_count}회)`;
}
exports.getShipmentDelayStatusLabel = getShipmentDelayStatusLabel;
function getProductItemPriceInfo(product_item, additional_option_detail_list) {
  const { option_list, option_type } = product_item.product;
  const product_price = product_item.price;
  if (additional_option_detail_list && option_type === 'PRODUCT_LINK') {
    const product_item_price = additional_option_detail_list.reduce((acc, selected_option) => {
      if (selected_option.option_code && selected_option.value_code) {
        // 연동형의 경우 code가 있고 추가입력형의 경우 code가 없음
        const selected_option_info = option_list.find((option) => option.code === selected_option.option_code);
        const selected_value =
          selected_option_info &&
          selected_option_info.value_set.find((value) => value.code === selected_option.value_code);
        return acc + ((selected_value && selected_value.additional_price) || 0);
      }
      return acc;
    }, product_price);
    return {
      price: product_item_price,
      price_delta: product_item_price - product_price,
    };
  }
  return {
    price: product_item.price,
    price_delta: product_item.price_delta,
  };
}
exports.getProductItemPriceInfo = getProductItemPriceInfo;
